<template>  
<div> <!-- root element start -->

    <div  class="row">
      <div v-if="loading == 0" class="col-12 mt-4">
        <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
      </div>
    </div>

    <div v-if="loading == 1" class="row">

      

      <div class="col-12">
          <div class="card border-0">
            <div class="card-header h5 bg-transparent border-0">Quick Add User</div>
            <div class="card-body">


              <div class="row"><!--  name row -->

                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Name</span>
                </div>

                <div class="col-md-6">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label class="d-none d-md-block" for="exampleInputEmail1">First Name</label>
                      <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="First Name" v-model="f_name">
                    </div>
                    <div class="form-group col-md-6">
                      <label for="exampleInputEmail1">Last Name</label>
                      <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="Last Name" v-model="l_name">
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                </div>
                
              </div>

              <hr class="bg-dark">

              <div class="row"><!--  email row -->

                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Email</span>
                </div>

                <div class="col-md-6">
                  <div class="row">
                    <div class="form-group col-12">
                      <label class="d-none d-md-block" for="exampleInputEmail1">Email</label>
                      <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="Email" v-model="email">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <small class="text-muted">The email listed here acts as not just the destination for emails, but also as the username for the user.</small>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                </div>
              </div>

              <hr class="bg-dark">

              <div class="row"><!--  email row -->

                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Password</span>
                </div>

                <div class="col-md-6">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label class="d-none d-md-block" for="exampleInputEmail1">Password</label>
                      <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="Password" v-model="password">
                    </div>
                    <div class="form-group col-md-6">
                      <label class="d-none d-md-block" for="exampleInputEmail1">Confirm Password</label>
                      <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="Confirm Password" v-model="confirm">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <small class="text-muted">A password must be at least ten characters, including 1 lowercase, 1 uppercase, 1 number, and 1 special character.</small>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                </div>
              </div>

              <hr class="bg-dark">

              <div class="row"><!--  status row -->
                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Status</span>
                </div>

                <div class="col-md-6">
                  <div class="row mb-2">
                    <div class="col-md-4">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" id="exampleRadios1" value="0" v-model="status">
                        <label class="form-check-label" for="exampleRadios1">
                          Active
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-check">
                        <input class="form-check-input" type="radio" id="exampleRadios2" value="1" v-model="status">
                        <label class="form-check-label" for="exampleRadios2">
                          Suspended
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-check disabled">
                        <input class="form-check-input" type="radio" id="exampleRadios3" value="2" v-model="status">
                        <label class="form-check-label" for="exampleRadios3">
                          Closed
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <small class="text-muted"><strong>Active</strong> = full rights and abilities. <strong>Suspended</strong> = Limited creation privileges. <strong>Closed</strong> = No rights or privileges, cannot login.</small>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                </div>
              </div>

              <hr class="bg-dark">

              <div class="row"><!--  role row -->
                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Role</span>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label class="d-none d-md-block" for="exampleFormControlSelect1">Role</label>
                    <select class="form-control" id="exampleFormControlSelect1" v-model="role">
                      <option value="n">Select a Role</option>
                      <option value="0">Sales Person</option>
                      <option value="1">Sales Manager</option>
                      <option value="2">Bid Manager</option>
                      <option value="3">Admin</option>

                    </select>
                  </div>
                </div>

                <div class="col-md-6">
                </div>

              </div>

              <hr class="bg-dark">



              <div v-if="role == '0'" class="row"><!--  if user, sales manager row -->
                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Manager</span>
                </div>

                <div class="col-md-8">
                  <div class="row">

                    <div class="col-md-6">
                      <label for="exampleFormControlSelect1">Select Manager</label>

                      <div class="form-group">
                        <select class="form-control" id="exampleFormControlSelect1" v-model="smAssign">
                          <option value="0">Select a Manager</option>
                          <option v-for="(sm, index) in smList" :value="sm.id">{{sm.f_name}} {{sm.l_name}}</option>
                        </select>
                      </div>

                    </div>
                
                  </div>
                  
                </div>

                <div class="col-md-2">
                </div>

              </div>

              <hr v-if="role == '0'" class="bg-dark">

              <div class="row"><!--  name row -->

                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Profile</span>
                </div>

                <div class="col-md-8">
                  <div class="row">
                    <div class="form-group col-md-8">
                      <label class="d-none d-md-block" for="exampleInputEmail1">Customer Facing Email</label>
                      <input type="email" class="form-control" aria-describedby="emailHelp" placeholder="Customer Facing Email" v-model="c_email">
                    </div>
                    <div class="form-group col-md-4">
                      <label for="exampleInputEmail1">Customer Facing Phone</label>
                      <VuePhoneNumberInput v-model="c_phone"
                        default-country-code="US"
                        no-country-selector
                        no-validator-state
                      />
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                </div>
                
              </div>

              <hr class="bg-dark">
              <div class="row mb-4"><!--  status row -->
                <div class="col-md-12 text-right">
                  <button @click="submitUser" class="btn btn-success">Submit</button>
                </div>
              </div>

            </div>
          </div>
      </div>
    </div>


</div> <!-- root element end -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import {store} from '../../stores/admin-user-store.js'


// import catMain from '../InstComponents/CategoryComponents/category-main.vue'


export default {
  store,
  data: function () {
    return { 
      loading: 1,
      smList: [],
      smAssign: '0',
      f_name: '',
      l_name: '',
      email: '',
      password: '',
      confirm: '',
      status: '',
      role: 'n',
      c_phone: '',
      c_email: '',
    }
  },
  computed: {
    prop1 () { return this.$store.state.prop1 },


  },
  watch: {
    
  },
  mounted() {

    this.getAllSMs();
  },
  methods: {
    changeRightView(name, prop1, prop2) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2 }); },
    getUserArray() { this.$store.dispatch("getAllUsers"); },
    getAllSMs() {
      var _this = this;
      axios.get('/admin/utility/getallactivesm')
        .then(function (response) {
        var a = response.data.data;
        _this.smList = a;
      });
    },
    
    submitUser() {
      var _this = this;
      var valErrors = [];
      if(_this.f_name == '' || _this.f_name == null) { valErrors.push("First name is required!") }
      if(_this.f_name.length <= 2 ) { valErrors.push("First name requires more than two letters!") }
      if(_this.l_name == '' || _this.l_name == null) { valErrors.push("Last name is required!") }
      if(_this.l_name.length <= 2 ) { valErrors.push("Last name requires more than two letters!") }
      if(_this.email == '' || _this.email == null) { valErrors.push("An email is required!") }
      var mailformat = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      if(!_this.email.match(mailformat)) { valErrors.push("A VALID email is required!") }

      // // var passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{10,})/;
      // if(!_this.password.match(passRegex)) { valErrors.push("A VALID password must be at least ten characters, including 1 lowercase, 1 uppercase, 1 number, and 1 special character!") }  
      var passRegex1 = /^(?=.*[a-z])/;
      var passRegex2 = /^(?=.*[A-Z])/;
      var passRegex3 = /^(?=.*[0-9])/;
      var passRegex4 = /^(?=.*[!@#\$%\^&\*])/;
      var passRegex5 = /^(?=.{10,})/;
      if(!_this.password.match(passRegex5)) { valErrors.push("A VALID password must include at least 10 characters!") }
      if(!_this.password.match(passRegex1)) { valErrors.push("A VALID password must include at least 1 lowercase character!") }  
      if(!_this.password.match(passRegex2)) { valErrors.push("A VALID password must include at least 1 uppercase character!") } 
      if(!_this.password.match(passRegex3)) { valErrors.push("A VALID password must include at least 1 numeric character!") } 
      if(!_this.password.match(passRegex4)) { valErrors.push("A VALID password must include at least 1 special character!") }   

      if(_this.password == '' || _this.password == null) { valErrors.push("A password is required!") } 
      if(_this.confirm == '' || _this.confirm == null) { valErrors.push("A password confirmation is required!") }
      if(_this.password != _this.confirm) {  valErrors.push("A password must match it's confirmation!") }
      if(_this.status == '' || _this.status == null) { valErrors.push("A status is required!") }
      if(_this.role == '' || _this.role == null || _this.role == 'n') { valErrors.push("A role is required!") }

      if(_this.role == 0) {
        if(_this.smAssign == 'n' || _this.smAssign == '' || _this.smAssign == null) {
          valErrors.push("A user must have a sales manager assigned!")
        }
      }

      var mailformat = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      if(!_this.c_email.match(mailformat)) { valErrors.push("A VALID customer facing email is required!") }

      var phoneFormat = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
      if(_this.c_phone != '' && _this.c_phone != null) {
        if(!_this.c_phone.match(phoneFormat)) { valErrors.push("The customer facing phone number you entered is invalid!") }  
      }

      if(valErrors.length > 0) {
        var errors = valErrors;
        var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
        $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
        errorsHTML += '</ul></div>';
        _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
        return false;
      }

      _this.$toastr.warning('Sending new user information.', 'Please wait!')
      axios.post('/admin/utility/submitqauser',{
        f_name: _this.f_name,
        l_name: _this.l_name,
        email: _this.email,
        password: _this.password,
        password_confirmation: _this.confirm,
        status: _this.status,
        role: _this.role,
        smAssign: _this.smAssign,
        c_email: _this.c_email,
        c_phone: _this.c_phone
      })
      .then(function (response) {
        var msg = response.data.msg;
        _this.$toastr.remove()
        _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
        _this.getUserArray();
        _this.changeRightView('user-list','','');
      })
      .catch(function (error) {
        var errors = error.response.data.errors;
        var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
        $.each(errors, function(key, value){ errorsHTML += '<li>' + value[0] + '</li>' });
        errorsHTML += '</ul></div>';
        _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
      })
    },
    
  },    
  components:{
    ScalingSquaresSpinner,
    VuePhoneNumberInput,
  },
  filters: {

  }
}
</script>
